import React, { forwardRef, useImperativeHandle, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/boardList.module.scss';
//hooks
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useAdminStore from 'src/webapp/stores/admin.store';
import useComnStore from 'src/webapp/stores/comn.store';
//CompWrapper
import Element from 'src/webapp/views/wrapper/Element';
import Button from 'src/webapp/views/component/Button';//버튼엘리먼트

const BannerList = forwardRef((props, ref) => {
    const navigator = useNavigate();
    //hook
    const { axiosMultiPartHandler } = useAxiosHook();
    //store
    const { admin } = useAdminStore();
    const { setMessage } = useComnStore();
    const { list, setList } = props;
    /* ==================== 공지사항삭제 ==================== */
    const isLock = useRef(false);
    const bannerDeleteAPI = async(data) => {
        if(!window.confirm("데이터를 삭제한 후에는 다시 복구할 수 없습니다.\n삭제하시겠습니까?")) { return; }
        try {
            if (isLock.current) { return; }
            isLock.current = true;
            const DATA = new FormData();
            let variables = {
                SEQ_NO: data.SEQ_NO,   
                ADMIN_ID: admin.COMN_ID,   //upsert 처리 관리자아이디
                STATE: 3,      //처리유형 - 1.등록, 2.수정, 3.삭제
            };
            DATA.append("file", []);
			DATA.append('requestDTO', new Blob([JSON.stringify(variables)]), { type: "application/json" });
            const result = await axiosMultiPartHandler("siteBannerUpsertForAdmin.do", DATA);
            const isOk = result && result.message === "SUCCESS";
            if(isOk){setMessage({type:1, label:`배너 삭제가 완료되었습니다.`});setList(before => before.filter((item) => item.SEQ_NO !== data.SEQ_NO));return;}
            setMessage({type:2, label:`배너 삭제에 실패 하였습니다.`});

        } finally { isLock.current = false; }
    }
    /* ==================== 공지사항삭제 ==================== */
    const [ toggle,setToggle ] = useState(null);//공지내용토글
    const statusFilter = (data) => {
        let result = "";
        switch(data.STATUS){
            case "B": result = `${data.START_DATE}부터 게시예정`; break;
                case "I": result = '게시중';break;
                    case"E": result = '종료';
        }

        return result;
    }

    return ( 
        <>
        <Element tag={`div`} className={styles.boardListContainer}>
            <Element tag={`ul`}>
                {list.length > 0 && list.map((item, i) =>
                    <Element key={item.SEQ_NO} tag={`li`}>
                        <Element tag={`div`} className={toggle === item ? styles.selected : null}>
                            <Element tag={`div`} className={styles.title}>
                                <Element tag={`div`}><Element tag={`h2`} style={{width:'25rem'}}>{item.TITLE}</Element></Element>
                                <Element tag={`div`} className={styles.btnArea}>
                                    <Button anyprop={(e) => bannerDeleteAPI(item)} class={"subtitle"} icon="fa-light fa-trash-can" label={"삭제하기"} ></Button>
                                    <Button anyprop={(e) => navigator("reg",{state:item})} class={"subtitle"} icon="fa-light fa-pen-to-square" label={"수정하기"} ></Button>
                                    <a onClick={(e) => setToggle(toggle === item ? {} : item)}><FontAwesomeIcon icon={["fa-light", toggle === item ? "fa-chevron-up": "fa-chevron-down"].join(" ")} /></a>
                                </Element>
                            </Element>
                            <Element tag={`div`} className={styles.info}>
                                <Element tag={`div`}><Element tag={`span`}>{item.START_DATE.split(".")[0] + " ~ " + item.END_DATE.split(".")[0]}</Element></Element><Element tag={`hr`} />
                                <Element tag={`div`}><Element tag={`span`}>{statusFilter({STATUS:item.STATUS, START_DATE:item.START_DATE.split(".")[0]})}</Element></Element>
                            </Element>
                        </Element>
                        {toggle === item ? 
                            <Element tag={`article`}>
                                <img height={100} src={process.env.REACT_APP_IMAGE_URL+item.IMG_SRC} />
                                <Element tag={`pre`}>{item.SUB_TITLE}</Element>
                            </Element>
                        : null}
                    </Element>
                )}
            </Element>
        </Element>
        </>
	)
})
export default BannerList;